import { render, staticRenderFns } from "./404page.vue?vue&type=template&id=c6caa1bc&scoped=true"
import script from "./404page.vue?vue&type=script&lang=js"
export * from "./404page.vue?vue&type=script&lang=js"
import style0 from "./404page.vue?vue&type=style&index=0&id=c6caa1bc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6caa1bc",
  null
  
)

export default component.exports